import { clsx, type ClassValue } from 'clsx';

/** Join conditional class names. (No tailwind-merge: components avoid conflicting utilities.) */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}
